/* AagamStuti profile script: the saved pieces and the devta picker on the My Mandir page. Plain JavaScript, no libraries.
   Saved pieces read the same browser list the heart buttons write (localStorage "as-wish"). Product cards come from the
   Section Rendering API, so they look and behave exactly like every other card in the shop. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.querySelector('[data-me]');
  if (!root) return;

  var WISH_KEY = 'as-wish';
  var DEVTA_KEY = 'as-devta';
  /* Start of the store's web address for this language or market, for example "/" or "/en-in/" */
  var base = (window.AS && window.AS.routes && window.AS.routes.root) || '/';
  if (base.charAt(base.length - 1) !== '/') base += '/';

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function read(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function write(key, val) { try { if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, val); } catch (e) {} }
  function saved() {
    var list = [];
    try { list = JSON.parse(read(WISH_KEY) || '[]'); } catch (e) { list = []; }
    return Array.isArray(list) ? list : [];
  }

  /* Fetch a section's HTML and hand back the product cards inside it. */
  function cardsFrom(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) return [];
      return res.text();
    }).then(function (html) {
      if (!html) return [];
      var holder = doc.createElement('div');
      holder.innerHTML = html;
      return Array.prototype.slice.call(holder.querySelectorAll('.as-plate'));
    }).catch(function () { return []; });
  }

  function paintHearts(scope) {
    var list = saved();
    $$('[data-wish]', scope).forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false');
    });
  }

  function skeleton(n) {
    var out = '';
    for (var i = 0; i < n; i++) out += '<div class="as-me__skel" aria-hidden="true"></div>';
    return out;
  }

  /* ---------- Saved pieces ---------- */
  var savedBlock = $('[data-saved]');
  var grid = savedBlock ? $('[data-saved-grid]', savedBlock) : null;
  var empty = savedBlock ? $('[data-saved-empty]', savedBlock) : null;

  function showEmpty(isEmpty) {
    if (empty) empty.hidden = !isEmpty;
    if (grid) grid.hidden = isEmpty;
  }

  /* Keep the grid in step with the browser's list: drop cards that are no longer saved, fetch only the new ones. */
  var syncing = 0;
  function syncSaved() {
    if (!savedBlock || !grid) return;
    savedBlock.hidden = false;
    var handles = saved().slice().reverse().slice(0, 12);
    var have = {};
    $$('.as-plate', grid).forEach(function (card) {
      var heart = $('[data-wish]', card);
      if (heart) have[heart.getAttribute('data-wish')] = card;
    });
    var need = handles.filter(function (h) { return !have[h]; });
    if (!handles.length) { grid.innerHTML = ''; showEmpty(true); return; }
    if (!need.length && !grid.querySelector('.as-me__skel')) {
      handles.forEach(function (h) { grid.appendChild(have[h]); });
      $$('.as-plate', grid).forEach(function (card) { if (handles.indexOf($('[data-wish]', card).getAttribute('data-wish')) === -1) card.remove(); });
      showEmpty(false);
      return;
    }
    var mine = ++syncing;
    showEmpty(false);
    if (!grid.children.length) grid.innerHTML = skeleton(Math.min(handles.length, 4));
    grid.setAttribute('aria-busy', 'true');
    Promise.all(need.map(function (h) {
      return cardsFrom(base + 'products/' + encodeURIComponent(h) + '?section_id=profile-saved').then(function (cards) { return cards[0] || null; });
    })).then(function (fetched) {
      if (mine !== syncing) return;
      var fresh = {};
      need.forEach(function (h, i) { if (fetched[i]) fresh[h] = fetched[i]; });
      var keep = [];
      handles.forEach(function (h) { var card = have[h] || fresh[h]; if (card) keep.push(card); });
      grid.innerHTML = '';
      keep.forEach(function (card) { grid.appendChild(card); });
      grid.removeAttribute('aria-busy');
      paintHearts(grid);
      showEmpty(keep.length === 0);
    });
  }

  /* The theme script flips a heart first; look at the list just after it has, wherever on the page the heart was. */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-wish]')) setTimeout(syncSaved, 0);
  });

  /* ---------- Devta picker ---------- */
  var devtaBlock = $('[data-devta]');
  var chips = devtaBlock ? $$('[data-devta-chip]', devtaBlock) : [];
  var out = devtaBlock ? $('[data-devta-out]', devtaBlock) : null;
  var token = 0;

  function paintChips(active) {
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-devta-chip') === active ? 'true' : 'false'); });
  }

  /* Shopify's own search is fuzzy: it pads a few real matches with loosely related pieces. So the picker reads the
     shop's product list once (title, tags, handle, in stock), keeps the pieces whose title or tags START with one of
     the devta's words, and only then asks the theme for those cards. The short list is remembered for the visit. */
  var INDEX_KEY = 'as-devta-index';
  var indexPromise = null;

  function fetchFeed(page, acc) {
    return fetch(base + 'products.json?limit=250&page=' + page, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('feed');
      return res.json();
    }).then(function (data) {
      var items = (data && data.products) || [];
      items.forEach(function (p) {
        var tags = Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || '').replace(/,/g, ' ');
        var live = (p.variants || []).some(function (v) { return v.available !== false; });
        acc.push({ h: p.handle, t: String(p.title || '').toLowerCase(), g: (tags + ' ' + (p.product_type || '')).toLowerCase(), a: live ? 1 : 0 });
      });
      return items.length === 250 && page < 4 ? fetchFeed(page + 1, acc) : acc;
    });
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    try {
      var cached = JSON.parse(sessionStorage.getItem(INDEX_KEY) || 'null');
      if (Array.isArray(cached) && cached.length) return (indexPromise = Promise.resolve(cached));
    } catch (e) {}
    indexPromise = fetchFeed(1, []).then(function (list) {
      if (list.length) { try { sessionStorage.setItem(INDEX_KEY, JSON.stringify(list)); } catch (e) {} }
      return list;
    }).catch(function () { indexPromise = null; return []; });
    return indexPromise;
  }

  /* A word matches where a word of the title or tags begins with it: "shiv" finds Shivling, not "worship". */
  function matcher(chip) {
    var raw = chip.getAttribute('data-words') || chip.getAttribute('data-query') || '';
    var words = raw.split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
    if (!words.length) return null;
    var safe = words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return new RegExp('(?:^|[^a-z0-9\\u0900-\\u097f])(?:' + safe.join('|') + ')');
  }

  function viaFeed(list, re) {
    var buckets = [[], [], [], []];
    list.forEach(function (p) {
      var inTitle = re.test(p.t);
      if (!inTitle && !re.test(p.g)) return;
      buckets[(p.a ? 0 : 2) + (inTitle ? 0 : 1)].push(p.h);
    });
    var handles = buckets[0].concat(buckets[1], buckets[2], buckets[3]).slice(0, 8);
    return Promise.all(handles.map(function (h) {
      return cardsFrom(base + 'products/' + encodeURIComponent(h) + '?section_id=profile-saved').then(function (cards) { return cards[0] || null; });
    })).then(function (cards) { return cards.filter(Boolean); });
  }

  /* If the product list cannot be read, fall back to the shop search and keep only cards that really mention the devta. */
  function viaSearch(url, re) {
    return cardsFrom(url + '&section_id=profile-picks').then(function (cards) {
      return cards.filter(function (c) { return re.test((c.textContent || '').toLowerCase().replace(/\s+/g, ' ')); }).slice(0, 8);
    });
  }

  function loadPicks(chip) {
    if (!out) return;
    var mine = ++token;
    if (!chip) { out.innerHTML = ''; return; }
    var name = chip.getAttribute('data-devta-chip');
    var query = chip.getAttribute('data-query');
    var re = matcher(chip);
    var searchUrl = base + 'search?q=' + encodeURIComponent(query) + '&type=product';
    out.setAttribute('aria-busy', 'true');
    out.innerHTML = '<div class="as-wall as-me__wall">' + skeleton(4) + '</div>';
    (re ? loadIndex().then(function (list) { return list.length ? viaFeed(list, re) : viaSearch(searchUrl, re); }) : Promise.resolve([])).then(function (cards) {
      if (mine !== token) return;
      out.removeAttribute('aria-busy');
      out.innerHTML = '';
      var head = doc.createElement('div');
      head.className = 'as-me__pickhead';
      var title = doc.createElement('h3');
      title.className = 'as-me__pickt';
      title.textContent = cards.length ? 'Pieces for ' + name : 'Nothing for ' + name + ' just yet';
      head.appendChild(title);
      var more = doc.createElement('a');
      more.className = 'as-ulink';
      more.href = searchUrl;
      more.textContent = 'Search for ' + name;
      head.appendChild(more);
      out.appendChild(head);
      if (cards.length) {
        var wall = doc.createElement('div');
        wall.className = 'as-wall as-me__wall';
        cards.forEach(function (c) { wall.appendChild(c); });
        out.appendChild(wall);
        paintHearts(wall);
      }
    });
  }

  if (devtaBlock) {
    var hideEmpty = devtaBlock.getAttribute('data-hide-empty') === 'true';
    /* With the product list in hand, drop the chips the shop has nothing for. If the list cannot be read, show them all. */
    var ready = !hideEmpty ? Promise.resolve() : loadIndex().then(function (list) {
      if (!list.length) return;
      chips.forEach(function (c) {
        var re = matcher(c);
        if (re && !list.some(function (p) { return re.test(p.t) || re.test(p.g); })) c.hidden = true;
      });
    });
    ready.then(function () {
      if (!chips.some(function (c) { return !c.hidden; })) return;
      devtaBlock.hidden = false;
      var current = read(DEVTA_KEY);
      var start = chips.filter(function (c) { return !c.hidden && c.getAttribute('data-devta-chip') === current; })[0] || null;
      paintChips(start ? current : null);
      if (start) loadPicks(start);
    });
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var name = chip.getAttribute('data-devta-chip');
        var turnOff = chip.getAttribute('aria-pressed') === 'true';
        write(DEVTA_KEY, turnOff ? null : name);
        paintChips(turnOff ? null : name);
        loadPicks(turnOff ? null : chip);
      });
    });
  }

  syncSaved();
})();
